module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-23.29ddc486.png";